<template>
  <v-card
    class="elevation-4 check-in-client-card check-in-client-card--selected"
    hover>
    <v-card-title primary-title>
      <div class="check-in-client-card__headline headline">
        <span>Hello</span>
      </div>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs8 offset-xs2 class="check-in-client-card__message">
          <div>
            <span v-if="location.schedule_type === 'schedule.thirty' || location.schedule_type === 'schedule.kartThirty'">
              It doesn't look like we have you scheduled today for an appointment. Would you like to view a list of available appointments?
            </span>
            <span v-else>
              The wait time is currently {{ waitTime }} min &amp; we will notify you via text when you are next in line. Knowing the wait time, would you like to reserve a spot today?
            </span>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <span v-if="timer">This will close in {{timer}} seconds.</span>
      <v-spacer></v-spacer>

      <v-btn class="check-in-client-card__button" outline @click.prevent="resetCheckIn">No</v-btn>
      <v-btn class="check-in-client-card__button" color="primary" @click.prevent="showScheduler">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { apis } from '@danckuts/api-js'
import appointmentService from '@/framework/appointment/appointmentService'
import moment from 'moment'

export default {
  data: function () {
    return {
      timer: undefined,
      waitTime: undefined
    }
  },
  mounted () {
    this.setAutoTimer(30)
    this.getCurrentWaitTime()
  },
  computed: {
    ...mapGetters({
      location: 'user/getLocation'
    })
  },
  methods: {
    checkInClient () {
      appointmentService.checkInClient({ id: this.nextAppointment.Id, clientId: this.client.Id })
    },
    getCurrentWaitTime () {
      const today = moment().format('YYYY-MM-DD')
      apis.AppointmentService.search(this.location.id.toLowerCase(), today).then(res => {
        const cutting = res.filter(a => a.status === 30)
        const waiting = res.filter(a => a.status <= 20)
        if (cutting.length <= 1 && waiting.length <= 1) {
          this.waitTime = 'zero'
          return
        }
        const isEven = (waiting.length % 2) === 0
        const calcWaiting = waiting.filter((w, i) => {
          if (isEven) {
            return (i % 2 === 1)
          }
          return (i % 2 === 0)
        })
        this.waitTime = calcWaiting.length * 25
      })
    },
    resetCheckIn () {
      this.stopTimer()
      this.$store.commit('checkIn/resetCheckIn')
    },
    runTimer () {
      setTimeout(() => {
        if (this.timer < 1) {
          this.resetCheckIn()
        } else {
          this.timer--
          this.runTimer()
        }
      }, 1000)
    },
    setAutoTimer (time) {
      this.timer = time || 15
      this.runTimer()
    },
    showScheduler () {
      this.stopTimer()
      this.$emit('openScheduler')
    },
    stopTimer () {
      if (this.timer) {
        this.timer = undefined
      }
    }
  }
}
</script>

<style lang="scss">
.check-in-client-card {
  &__headline {
    display: block;

    span {
      display: inline-block;
      font-size: 1.4em;
      font-weight: bold;
      padding-right: 5px;
    }
  }

  &__selected {
    background-color: red;
  }

  &__button {
    text-transform: capitalize;
  }

  &__message {
    font-size: 1.2em;
    font-weight: 500;
  }

  &__value {
    font-size: 1.2em;
    font-weight: 600;

    small {
      font-size: 0.9em;
      font-weight: normal;
    }
  }
}
</style>
